/* ================================================== */
/* PLAYERS
/* ================================================== */

var players = [];

$(document).ready(function() {
	$('[data-provider="vimeo"]').each(function(index, element) {
		// Init
		var isBackground = $(element).is('[data-player-background]') && $(element).data('player-background') !== 'true',
			ratio = $(element).is('[data-player-ratio]'),
			options = {
			url: $(element).data('player-url'),
			width: $(element).data('player-width'),
			height: $(element).data('player-height'),
			controls: (isBackground) ? false : true,
			title: false,
			byline: false
		};
		players[index] = new Vimeo.Player($(element), options);
		// players[index].setColor('#009949');

		// Update
		if (isBackground) {
			players[index].setMuted(true);
			players[index].ready().then(function() {
				if (ratio) $('iframe', element).css('height', 'calc(100vw * ' + $(element).data('player-ratio') + ')');
				gsap.to($('iframe', element), { opacity: 1, delay: 1.25, duration: 0.2 });
			});
			ScrollTrigger.create({
				trigger: $(element),
				onToggle: function(self) {
					(self.isActive) ? players[index].play() : players[index].pause();
				}
			});
		} else {
			updateEmbedSize($(element));
			players[index].ready().then(function() {
				updateEmbedSize($(element));
				gsap.to($(element), { opacity: 1, duration: 0.2 });
			});
		}
	});
});